import type { VFC } from 'react';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import ConnectedSwitch from '@/containers/ConnectedSwitch';
import { detectMobileOS } from '@/utils/detectMobileOS';
import { AuthGuard } from '../components/AuthGuard';
import { ForgotPasswordPage } from '../routes/forgot_password/Page';
import { LoginPage } from '../routes/login/Page';
import { OneTimePasswordPage } from '../routes/token/routes/one-time/Page';
import { SetPasswordPage } from '../routes/token/routes/set_password/Page';
import { getStoreUrl } from '../utils/redirectToStore';
import { TwoFactorPage } from '../routes/two-factor/Page';
import { IdentifyPage } from '../routes/identify/Page';
import { LostDevicePage } from '../routes/lost_device/Page';
import { ConsentPage } from '../routes/consent/Page';

export const AuthRouter: VFC = () => {
  const match = useRouteMatch();

  return (
    <ConnectedSwitch>
      <Route exact path={`${match.path}forgot-password`} render={() => <ForgotPasswordPage />} />

      {/* Protected routes - require user to go through identify first AND have the appropriate method */}
      <Route
        exact
        path={`${match.path}one-time-password`}
        render={() => (
          <AuthGuard requiredMethod="oneTimePassword">
            <OneTimePasswordPage />
          </AuthGuard>
        )}
      />

      <Route
        exact
        path={`${match.path}token/set-password`}
        render={() => (
          <AuthGuard requireIdentified={false}>
            <SetPasswordPage />
          </AuthGuard>
        )}
      />

      <Route
        exact
        path={`${match.path}login`}
        render={() => (
          <AuthGuard requireIdentified>
            <LoginPage />
          </AuthGuard>
        )}
      />

      <Route exact path={`${match.path}two-factor`} render={() => <TwoFactorPage />} />

      <Route exact path={`${match.path}lost-device`} render={() => <LostDevicePage />} />

      <Route exact path={`${match.path}consent`} render={() => <ConsentPage />} />

      <Route path={`${match.path}token`} render={() => <Redirect to="/" />} />

      <Route
        exact
        path={`${match.path}app-download`}
        render={() => {
          window.location.replace(getStoreUrl(detectMobileOS()));
          return null;
        }}
      />

      {/* Identify page - entry point for authentication */}
      <Route path={match.path} render={() => <IdentifyPage />} />
    </ConnectedSwitch>
  );
};
